import axios from 'axios'
import jwt from '@src/auth/jwt/useJwt'

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL
})

instance.interceptors.request.use(
  async (config) => {
    // ** Get token from localStorage
    const accessToken = JSON.parse(jwt.getToken())

    // ** If token is present add it to request's Authorization Header
    if (accessToken) {
      // ** eslint-disable-next-line no-param-reassign
      config.headers.Authorization = `${jwt.jwtConfig.tokenType} ${accessToken}`
    }
    return config
  },
  (error) => {
    Promise.reject(error)
  }
)

export const handleError = ({ message, data, status }) => {
  return Promise.reject({ message, data, status })
}

// Services not yet redeployed still answer a duplicate key with
// "A record with this value already exists ('X'). Key: UQ_…"; show what the
// updated services say instead, without the database key.
const friendlyDuplicate = (error) => {
  const body = error?.response?.data?.message
  if (error?.response?.status !== 409 || typeof body?.message !== 'string' || !body.message.includes('Key:')) {
    return
  }
  const value = /\('(.*)'\)/.exec(body.message)?.[1]
  body.message = value ? `'${value}' is already in use. Check whether it was saved already, or use a different value.` : 'This record already exists. Check whether it was saved already, or try different details.'
  body.code = 'DUPLICATE'
}

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    // ** const { config, response: { status } } = error
    const { config, response } = error
    const originalRequest = config

    // ** if (status === 401) {
    if (response && response.status === 401) {
      if (!jwt.isAlreadyFetchingAccessToken) {
        jwt.isAlreadyFetchingAccessToken = true
        jwt
          .refreshToken()
          .then((r) => {
            jwt.isAlreadyFetchingAccessToken = false

            // ** Update accessToken in localStorage
            jwt.setToken(r.data.accessToken)
            jwt.setRefreshToken(r.data.refreshToken)

            jwt.onAccessTokenFetched(r.data.accessToken)
          })
          .catch(() => {
            // ** If refresh token fails, clear storage and redirect to login
            jwt.isAlreadyFetchingAccessToken = false
            localStorage.removeItem(jwt.jwtConfig.storageTokenKeyName)
            localStorage.removeItem(jwt.jwtConfig.storageRefreshTokenKeyName)
            localStorage.removeItem('userData')
            window.location.href = '/login'
          })
      }
      const retryOriginalRequest = new Promise((resolve, reject) => {
        jwt.addSubscriber((accessToken) => {
          if (accessToken) {
            // ** Make sure to assign accessToken according to your response.
            // ** Check: https://pixinvent.ticksy.com/ticket/2413870
            // ** Change Authorization header
            originalRequest.headers.Authorization = `${jwt.jwtConfig.tokenType} ${accessToken}`
            resolve(instance(originalRequest))
          } else {
            reject(error)
          }
        })
      })
      return retryOriginalRequest
    }
    friendlyDuplicate(error)
    return Promise.reject(error)
  }
)

export default instance
